// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"d072d95c","165":"2b4cfbf4","208":"ac4932a3","479":"6d833519","584":"5905143e","677":"acf9acfb","968":"4f4964be"}[chunkId] + ".chunk.js";
};